"use client";

import React from "react";

import { strings } from "@perceptron/constants";
import { cn } from "@perceptron/utils/cn";
import { formatString } from "@perceptron/utils/string";

import { marketingHref } from "@demo/libs/marketing-link";
import { AgentState, useModelStore } from "@demo/store/model";

interface TermsAndPrivacyDisclaimerProps {
  className?: string;
}

export const TermsAndPrivacyDisclaimer = React.memo(function TermsAndPrivacyDisclaimer({
  className = "",
}: TermsAndPrivacyDisclaimerProps) {
  const agentState = useModelStore((state) => state.agentState);
  const agentText = useModelStore((state) => state.agentText);

  const isEmpty = agentText === "";
  const isIdle = agentState === AgentState.IDLE;

  return (
    <div
      className={cn(
        "px-8 text-center text-sm font-medium text-foreground-secondary transition-[max-height,opacity] duration-300 legal sm:px-4",
        {
          "max-h-full opacity-100": isEmpty && isIdle,
          "pointer-events-none max-h-0 overflow-hidden opacity-0": !isEmpty || !isIdle,
        },
        className,
      )}
      onClick={(e) => e.stopPropagation()}
    >
      {formatString(
        strings.termsAndPrivacyDisclaimer.text,
        <a
          className="underline hover:opacity-80"
          href={marketingHref("/terms-of-use")}
          rel="noopener noreferrer"
          target="_blank"
        >
          {strings.termsAndPrivacyDisclaimer.terms}
        </a>,
        <a
          className="underline hover:opacity-80"
          href={marketingHref("/privacy-policy")}
          rel="noopener noreferrer"
          target="_blank"
        >
          {strings.termsAndPrivacyDisclaimer.privacyPolicy}
        </a>,
      )}
    </div>
  );
});
